export { default } from './Stacheldraht';



// WEBPACK FOOTER //
// ./src/components/Stacheldraht/index.js